import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Subject } from 'rxjs/Subject';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ConfigLoyaltyService } from '../../integrate-loyalty/config-loyalty/services/config-loyalty.services';
import { ImageService } from '../../../../imageService';
import { Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: 'app-config-loyalty-product',
  templateUrl: './config-loyalty-product.component.html',
  styleUrls: ['./config-loyalty-product.component.css'],
  providers: [ConfigLoyaltyService]
})
export class ConfigLoyaltyProductComponent implements OnInit {
  @Output('hideCrating') hideCrating = new EventEmitter();
  @Input() detail: any = {};
  @Input() list_prods: any = [];
  @ViewChild('boxRetalStamps') boxRetalStamps;
  @ViewChild('campaign') campaign: ModalDirective;
  @ViewChild('scan') scan: ModalDirective;
  @ViewChild('confirm') confirm: ModalDirective;

  title = 'Gán chương trình loyalty';
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  addContent = '';
  listContent = [];
  unsubscribe$ = new Subject<void>();
  groupItems = [];
  stampList = [];
  loading = false;
  timeout: any = null;
  public user: any;
  titleLangSub: Subscription;
  formCratingBatch: FormGroup = this.fb.group({
    is_cratingStampsSingle: [true],
    is_cratingStampsList: [false],
    stampCode: ['', [Validators.required]],
    stampCodeList: this.fb.array([]),
    note: [null],
    service: [true],
  });
  isReadmore: Boolean = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private configLoyaltyService: ConfigLoyaltyService,
    private imageService: ImageService,
    private router: Router,
    public translate: TranslateService
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    if (this.titleLangSub) {
      this.titleLangSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.title = this.translate.instant('GAN_CHUONG_TRINH_LOYALTY') || 'Gán chương trình loyalty';
    this.titleLangSub = this.translate.onLangChange.subscribe((event) => {
      this.title = event.translations['GAN_CHUONG_TRINH_LOYALTY'] || 'Gán chương trình loyalty';

      const distributionAgent = $('#productListLoyaltyConfig');
      distributionAgent.select2({
        placeholder: this.translate.instant('CHON_SAN_PHAM_DROP_DOWN') || '-- Chọn sản phẩm --',
        allowClear: true,
      });
    });

    const distributionAgent = $('#productListLoyaltyConfig');
    distributionAgent.select2({
      placeholder: this.translate.instant('CHON_SAN_PHAM_DROP_DOWN') || '-- Chọn sản phẩm --',
      allowClear: true,
      ajax: {
        delay: 500,
        url: `${environment.api_evs}/product/list`,
        headers: {
          Authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          const page = params.page || 1;
          const pageSize = 10; // adjust based on your needs
          const offset = (page - 1) * pageSize;

          $('.select2-container').addClass('setIndex-1800');
          return {
            name: params.term, // search term
            offset: offset,
            limit: pageSize
          };
        },
        // tslint:disable-next-line:no-shadowed-variable
        processResults: function (data, params) {
          console.log('params', params)
          params.page = params.page || 1;
          return {
            results: data.data.products,
            pagination: {
              more: (params.page * 10) < data.data.count.count
            }
          };
        },
      },
      templateResult: this.formatRepo,
      templateSelection: this.formatRepoSelection,
      minimumResultsForSearch: 1,
    })
  }

  formatRepo(repo) {
    if (repo.loading) {
      return repo.text;
    }
    const $container = $(
      `<div class='select2-result-repository__title'>${repo.name}</div>`
    );
    return $container;
  }

  formatRepoSelection(repo) {
    return repo.name || repo.name;
  }

  backToList(data = {}) {
    this.hideCrating.emit(data);
  }

  submitFormConfigConfirm(data_post: any) {
    this.loading = true;
    this.confirm.hide();
    setTimeout(() => {
      let productIds = $('#productListLoyaltyConfig').val()
      if (productIds == null) {
        this.toastr.warning(this.translate.instant('SAN_PHAM_KHONG_DUOC_DE_TRONG'), this.translate.instant('THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      } else {
        productIds = productIds.map(Number)
      }
      let body = {};
      body = {
        productIds: productIds,
        stampGroups: null,
        agencyIds: null,
        campaignId: Number(this.myCampaign[0]),
        campaignCode: this.campaignCode,
        campaignType: this.campaignCode ? 1 : 0,
        giftCode: this.giftCode,
        priority: this.priority,
        applyScan: this.applyScan === null ? '' : Number(this.applyScan),
        systemType: 1
      };
      console.log('scan1', this.applyScan, ' piri1', this.priority);
      console.log('body', body);
      this.configLoyaltyService.configLoyalty(body).subscribe(
        (res) => {
          if (res.code === 1) {
            if (res.data !== null && res.data.acceptBoxed === false) {
              this.toastr.warning(res.data.msg, this.translate.instant('THONG_BAO'), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
              return;
            }
            this.giftCode = null;
            this.campaignCode = null;
            this.isCampaign = false;
            this.loading = false
            this.confirm.hide();
            this.toastr.success(this.translate.instant('GAN_CHUONG_TRINH_LOYALTY_THANH_CONG') +
              ' ' + this.translate.instant('THANH_CONG') + ':' + res.data.success + ' ' + this.translate.instant('THAT_BAI') + ': ' + res.data.fail,
              this.translate.instant('THONG_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            this.backToList({ isBack: false })
          } else {
            this.loading = false
            this.confirm.hide();
            this.toastr.warning(res.message, this.translate.instant('THONG_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }
        },
        (err) => {
          this.loading = false
          this.confirm.hide();
          this.toastr.warning(err.message, this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });

        }
      );

    }, 500);
  }

  data_campaign = []
  has_data_campaign: boolean = true;
  errorMessage: string = '';
  public pager: any;
  public pageIndex: number = 1;
  public page_size: number = 6;
  public totalRow: number = 0;
  public total_data_campaign: number = 0
  listOfChecked: string = '';
  list_id = [];
  checkSelectCampain: number = 0;
  myCampaign = {}
  isCampaign = false;
  public campaignCode: string;
  public giftCode: string;
  public changeService: Boolean = false;
  public changeIdetification: Boolean = false;
  public changeOverflow: Boolean = false;
  public applyScan: any = null;
  public priority: number = 0;

  loadCampaign() {
    this.campaign.show();
    let query = {
      page: this.pageIndex,
      pageSize: this.page_size,
      systemType: 1
    }
    this.configLoyaltyService.getListCampaignLoyalty(query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data_campaign = res.data.pagination.totalElements;
          let list: any = [];
          for (let _data of res.data.items) {
            let obj = {
              id: _data.id,
              name: _data.name,
              image: this.imageService.readSrcImage(_data.image, 'thumb_large'),
              status: _data.status,
              idEnd: _data.idEnd,
              statusTitle: _data.statusTitle,
              start: _data.start,
              end: _data.end,
              approved: _data.approved,
            };
            list.push(obj);
          }
          ;
          this.data_campaign = list
          console.log(this.has_data_campaign);
          if (list.length > 0) {
            this.has_data_campaign = true;
          } else {
            this.has_data_campaign = false;
          }
        } else {
          this.errorMessage = res.message;
        }
        // tslint:disable-next-line:no-unused-expression
        (err) => {
          console.log(err)
        }
      }
    )
  }

  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      // this.loading_left = true;
      this.loadCampaign();
    }
  }

  lastPageList() {
    this.pageIndex = this.pageIndex + 1;
    this.loadCampaign();
  }

  inputPageList(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      this.loadCampaign();
    }
  }

  onMyCampaign() {
    this.checkSelectCampain = 1;
    this.campaignCode = null
  }

  onOtherCampaign() {
    this.checkSelectCampain = 2;
    this.isCampaign = false
    this.myCampaign = {}
  }

  radioBoxChange(event) {
    this.listOfChecked = event.target.value;
    console.log('tuanba: ' + this.listOfChecked);
  }

  confirmCampaign() {
    this.myCampaign = this.listOfChecked.split(',');
    this.isCampaign = true;
    this.campaign.hide();
    this.pageIndex = 1;
    console.log(typeof (this.myCampaign));
  }

  onChangeService() {
    this.changeService = true;
    this.changeIdetification = false
    this.priority = 1;
    this.applyScan = 0;
  }

  radioBoxChangeService(event) {
    this.applyScan = event.target.value;
  }

  onChangeGuarantee() {
    this.scan.show();
    this.changeService = false;
    this.changeIdetification = false;
    this.changeOverflow = false;
    this.priority = 0;
    this.applyScan = null;
    console.log('scan', this.applyScan, ' piri', this.priority);
  }

  onChangeIdentification() {
    this.changeIdetification = true;
    this.changeService = false;
    this.changeOverflow = false;
    this.priority = 5;
    this.applyScan = 0;
  }

  radioBoxChangeIdentification(event) {
    this.applyScan = event.target.value;
  }

  onChangeOverflow() {
    this.changeIdetification = false;
    this.changeService = false;
    this.changeOverflow = true;
    this.priority = 3;
    this.applyScan = 0;

  }

  radioBoxChangeOverflow(event) {
    this.applyScan = event.target.value;
  }

  confirmGuarantee() {
    this.priority = 2;
    this.applyScan = null;
    this.scan.hide();
    console.log('scan', this.applyScan, ' piri', this.priority);
  }

  closeGuarantee() {
    this.priority = 0;
    this.applyScan = null;
    this.scan.hide();
    $('input[name="scan"]').attr('checked', false);
  }

  confimLoyalty() {
    this.confirm.show()
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-loyalty-v2/config-loyalty-product/config-loyalty-product.component.ts